import styled from 'styled-components';

export const Content = styled.div`
  cursor: pointer;
  position: relative;
  min-height: 94px;
  width: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  background-color: #171a1f;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);
  &.with-call {
    background-color:rgba(20, 88, 115, 0.75);
    box-shadow: 0 0 10px rgba(20, 88, 115, 0.1);
  }
`;

export const Barrier = styled.div`
  margin: 2px 0;
  width: 23px;
  height: 13px;
  background: url('/images/barrier.png');
  background-repeat: no-repeat;
`;

export const Id = styled.div`
  position: absolute;
  font-size: 14px;
  font-weight: bold;
  bottom: 5px;
  color: #171a1f;
  text-align: center;
  &.server,
  &.cashbox {
    padding: 2px 4px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.85);
    bottom: -14px;
  }
`;

export const IconTitle = styled.div`
  position: relative;
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  margin: 2px 0 5px 0;
  &.server,
  &.cashbox {
    img {
      position: absolute;
      top: -10px;
    }
  }
  &.server {
    img {
      top: -13px;
    }
  }
`;
